module.exports = __webpack_public_path__ + "4507e30f27456c1a2e27047e35e5fc5f.png";